import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { type IMenuItemProps, Menu, PageLayout } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { DiscoverPath } from 'pages/discover/route/discoverPath'
import { DiscoverContext } from 'pages/discover/context/context'
import { DiscoverStore } from 'pages/discover'
import { DiscoverMenuCollapseButton } from 'pages/discover/layout/DiscoverMenuCollapseButton'

export const DiscoverLayout = observer(() => {
  const entities = useEntitiesContext()
  const discoverStore = useMemo(() => new DiscoverStore(entities), [])

  const items: IMenuItemProps[] = [
    {
      key: 'capture',
      type: 'nav',
      to: DiscoverPath.capture,
      fullPath: true,
      disabledVueRouting: true,
      label: 'Capture',
      icon: 'magnet',
    },
    {
      key: 'connect',
      type: 'nav',
      to: DiscoverPath.connect,
      fullPath: true,
      disabledVueRouting: true,
      label: 'Connect',
      icon: 'messageCircleChecked',
    },
    {
      key: 'convert',
      type: 'nav',
      to: DiscoverPath.convert,
      fullPath: true,
      disabledVueRouting: true,
      label: 'Convert',
      icon: 'target2',
    },
    {
      key: 'care',
      type: 'nav',
      to: DiscoverPath.care,
      fullPath: true,
      disabledVueRouting: true,
      label: 'Care',
      icon: 'messageSmile',
    },
  ]

  const rightContent = (
    <>
      <DiscoverMenuCollapseButton />
      <Outlet />
    </>
  )

  return (
    <DiscoverContext.Provider value={discoverStore}>
      <PageLayout
        store={discoverStore.pageLayoutStore}
        leftContent={<Menu title='Discover' menuItems={items} />}
        rightContent={rightContent}
      />
    </DiscoverContext.Provider>
  )
})
